<zci-tile [navOverflowMenuConfig]="navOverflowMenuConfig">
    <p variant="secondary-independent" class="zci-text--bold c11n-space-stack-1x col">
        {{ accName }}
    </p>
    <p class="c11n-space-stack-1x">{{ accType | mapAccType }}</p>
    <p>{{ roleType | mapRoleType }}</p>
</zci-tile>
